"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = require("react");

// takes overflow of Safari iOS into account
var getNormalizedScrollY = function getNormalizedScrollY() {
  var scrollY = window.scrollY;

  if (scrollY >= document.documentElement.scrollHeight - window.innerHeight || scrollY < 0) {
    return null;
  }

  return scrollY;
};

function useScrollDirection(options) {
  options = options || {};
  var _options = options,
      _options$timeDebounce = _options.timeDebounce,
      timeDebounce = _options$timeDebounce === void 0 ? 350 : _options$timeDebounce;

  var _useState = (0, _react.useState)(0),
      counter = _useState[0],
      setCounter = _useState[1];

  var blockedRef = (0, _react.useRef)(false);
  var directionRef = (0, _react.useRef)(undefined); // wrapper to have access to up-to-date values in updateScroll closure

  var previousScrollY = (0, _react.useRef)(null);
  var timeout = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var updateScroll = function updateScroll() {
      var direction = directionRef.current;
      var blocked = blockedRef.current;
      var scrollY = getNormalizedScrollY();

      if (scrollY === null) {
        return;
      }

      if (previousScrollY.current !== null) {
        var newDirection;

        if (scrollY > previousScrollY.current) {
          newDirection = true;
        } else {
          newDirection = false;
        }

        if (newDirection !== direction && !blocked) {
          directionRef.current = newDirection;
          blockedRef.current = true;
          clearTimeout(timeout.current);
          timeout.current = setTimeout(function () {
            blockedRef.current = false;
          }, timeDebounce);
          setCounter(function (counter) {
            return counter + 1;
          });
        }
      }

      previousScrollY.current = scrollY;
    };

    window.addEventListener("scroll", updateScroll);
    updateScroll();
    return function cleanup() {
      window.removeEventListener("scroll", updateScroll);
      clearTimeout(timeout.current);
    };
  }, [timeDebounce]);
  return directionRef.current;
}

var _default = useScrollDirection;
exports["default"] = _default;